import {DateTime} from "luxon";
import QRCode from "qrcode";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import numbers from 'numeros_to_words';
export class Conciliacion{
    static imprimir(factura :any,cliente:any): Promise<any> {
        return new Promise((resolve,reject) => {
            let cuf = '';
            for (let i = 0; i < factura.cabecera.cuf.length; i++) {
                if ((i + 1) % 20 == 0) {
                    cuf += factura.cabecera.cuf.substring(i, i + 1) + "<br>";
                } else {
                    cuf += factura.cabecera.cuf.substring(i, i + 1);
                }
            }
            QRCode.toDataURL(process.env.VUE_APP_URLSIAT + "&cuf=" + factura.cabecera.cuf + "&numero=" + factura.cabecera.nroFactura + '&t=2').then(url => {
                factura.img = url;
                resolve(this.facturaFormato(factura, cliente,0,'nuevo',cuf))
            }).catch(err => {
                reject(err)
            })
        });
    }
    static setFecha(fecha: string): string {
        return DateTime.fromISO(fecha).toFormat('dd/MM/yyyy');
    }

    static setHora(): string {
        return DateTime.now().toFormat('HH:mm:ss');
    }

    static facturaFormato(factura: any, cliente: any,otrosIngresos:number,tipo:string,autorizacion:string) {
        console.log("factura",factura)
        console.log("cliente",cliente)

        let numeroAutorizacionCuf = '';
        for (let i = 0; i < factura.cabecera.cuf.length; i++) {
            if ((i + 1) % 20 == 0) {
                numeroAutorizacionCuf += factura.cabecera.numeroAutorizacionCuf.substring(i, i + 1) + "<br>";
            } else {
                numeroAutorizacionCuf += factura.cabecera.numeroAutorizacionCuf.substring(i, i + 1);
            }
        }


        numbers().Config._setSingular('');
        numbers().Config._setPlural('');
        // numbers().Config._setCentsSingular('CENTAVO');
        // numbers().Config._setCentsPlural('CENTAVOS');
        let textoCredito='';
        let montoCredito='';
        if (factura.cabecera.creditoFiscalIva == 0) {
            textoCredito = "DÉBITO";
            montoCredito = factura.cabecera.debitoFiscalIva;
        } else {
            textoCredito = "CRÉDITO";
            montoCredito = factura.cabecera.creditoFiscalIva;
        }

        const literal = numbers( Math.trunc(factura.cabecera.montoTotalConciliado)).toString();
        const centavos = Math.round((factura.cabecera.montoTotalConciliado - Math.trunc(factura.cabecera.montoTotalConciliado))*100);

        let detalle = ""
        for (let i = 0; i < factura.detalleOriginal.length; i++) {
            detalle += `<tr>
                    <td class="border">${factura.detalleOriginal[i].codigoProducto}</td>
                    <td class="border right">${factura.detalleOriginal[i].cantidad}</td>
                    <td class="border">UNIDAD (SERVICIOS)</td>
                    <td class="border">${factura.detalleOriginal[i].descripcion}</td>
                    <td class="border right">${factura.detalleOriginal[i].precioUnitario}</td>
                    <td class="border right">0</td>
                    <td class="border right">${factura.detalleOriginal[i].subTotal}</td>
                    </tr>`
        }
        let detalleConciliacion = ""
        // for (let i = 0; i < factura.detalleConciliacion.length; i++) {
        //     console.log(factura.detalleConciliacion[i])
        detalleConciliacion += `<tr>
                    <td class="border">${factura.detalleConciliacion.codigoProducto}</td>
                    <td class="border">${factura.detalleConciliacion.descripcion}</td>
                    <td class="border right">${factura.detalleConciliacion.montoOriginal}</td>
                    <td class="border right">${factura.detalleConciliacion.montoFinal}</td>
                    <td class="border right">${factura.detalleConciliacion.montoConciliado}</td>
                </tr>`
        // }
        return (''+
            '<style>'+
    '.bold{font-weight: bold;}'+
    '.text-h1{            font-size: 20px;}'+
    '.text-h5{            font-size: 8px;}'+
    '.text-h6{            font-size: 7px;}'+
    '.center{            text-align: center;}'+
    '.right{            text-align: right;}'+
    '.border{            border: 1px solid black}'+
    '.collapse{            border-collapse: collapse;}'+
    '.background{            background: #edf2f7}'+
    '.overflow-visible {            white-space: initial;}'+
        '</style>'+
        '<div style="position: absolute;left: 1px;width: 195mm;padding: 0.5cm;font-size: 12px;font-family: sans-serif;">'+
        '<table width="100%"  class="collapse" >'+
        '<tr>'+
            '<td width="33%">'+
        '<div class="bold center">'+factura.cabecera.razonSocialEmisor+'</div>'+
            '<div class="bold center">CASA MATRIZ</div>'+
        '<div class="center">No. Punto de Venta '+factura.cabecera.codigoPuntoVenta+'</div>'+
        '</td>'+
        '<td></td>'+
        '<td width="120px">'+
        '<table>'+
            '<tr>'+
                '<td valign=top width="130px">'+
        '<div class="bold">NIT</div>'+
            '<div class="bold">Nº NOTA</div>'+
        '<div class="bold">CÓD. AUTORIZACIÓN</div>'+
            '</td>'+
            '<td>'+
            '<div>'+factura.cabecera.nitEmisor+'</div>'+
            '<div>'+factura.cabecera.numeroNotaConciliacion+'</div>'+
            '<div style="width: 120px">'+autorizacion+'</div>'+
        '</td>'+
        '</tr>'+
        '</table>'+
        '</td>'+
        '</tr>'+
        '<tr>'+
        '<td>'+
            '<div class="center">'+
            ''+factura.cabecera.direccion+''+
            '</div>'+
            '<div class="center">Teléfono: '+factura.cabecera.telefono+'</div>'+
        '<div class="center">Oruro</div>'+
        '</td>'+
        '</tr>'+
        '<tr>'+
        '<td colspan="3">'+
        '<div class="bold center text-h1">'+
            'NOTA DE CONCILIACIÓN'+
        '</div>'+
        '</td>'+
        '</tr>'+
        '<tr>'+
        '<td colspan="2">'+
        '<table width="100%">'+
        '<tr>'+
            '<td>'+
                '<div class="bold">Fecha: </div>'+
        '</td>'+
        '<td>'+
        '<div>'+ this.setFecha(factura.cabecera.fechaEmision) +'</div>'+
        '</td>'+
        '</tr>'+
        '<tr>'+
        '<td>'+
            '<div class="bold">Nombre/Razón Social:</div>'+
        '</td>'+
        '<td>'+
        '<div>'+factura.cabecera.nombreRazonSocial+'</div>'+
        '</td>'+
        '</tr>'+
        '</table>'+
        '</td>'+
        '<td>'+
        '<table width="100%">'+
        '<tr>'+
            '<td class="right">'+
        '<div class="bold">NIT/CI/CEX:</div>'+
        '</td>'+
        '<td>'+
        '<div>'+factura.cabecera.numeroDocumento+' '+(factura.cabecera.complemento.toString()=== '[object Object]'?'':factura.cabecera.complemento)+'</div>'+
        '</td>'+
        '</tr>'+
        '<tr>'+
        '<td class="right">'+
        '<div class="bold">Cod. Cliente:</div>'+
        '</td>'+
        '<td>'+
        '<div>'+factura.cabecera.codigoCliente+'</div>'+
        '</td>'+
        '</tr>'+
        '</table>'+
        '</td>'+
        '</tr>'+
        '<tr>'+
        '<td colspan="2">'+
            '<h5>DATOS FACTURA ORIGINAL</h5>'+
        '<table width="100%">'+
        '<tr>'+
            '<td>'+
                '<div class="bold">N° Factura: </div>'+
        '</td>'+
        '<td>'+
        '<div>'+factura.cabecera.numeroFactura+'</div>'+
        '</td>'+
        '</tr>'+
        '<tr>'+
        '<td>'+
            '<div class="bold">Fecha Factura:</div>'+
        '</td>'+
        '<td>'+
        '<div>'+this.setFecha(factura.cabecera.fechaEmisionFactura)+'</div>'+
        '</td>'+
        '</tr>'+
        '</table>'+
        '</td>'+
        '<td>'+
        '<table width="100%">'+
        '<tr>'+
            '<td class="right">'+
        '<div class="bold">N° Autorización/CUF:</div>'+
        '</td>'+
        '<td>'+
        '<div>'+numeroAutorizacionCuf+'</div>'+
        '</td>'+
        '</tr>'+
        '</table>'+
        '</td>'+
        '</tr>'+
        '<tr valign="bottom">'+
        '<td colspan="3">'+
        '<table width="100%" class="collapse">'+
        '<tr class="background" >'+
        '<th class="border" width="50px" >CÓDIGO PRODUCTO</th>'+
        '<th class="border">CANTIDAD</th>'+
        '<th class="border">UNIDAD DE MEDIDA</th>'+
        '<th class="border">DESCRIPCIÓN</th>'+
        '<th class="border" width="60px">PRECIO'+' UNITARIO</th>'+
        '<th class="border">DESCUENTO</th>'+
        '<th class="border">SUBTOTAL</th>'+
        '</tr>'+
        detalle+
        '<tr>'+
        '<td colspan="4"></td>'+
            '<td class="border right text-h5 bold background" colspan="2">MONTO TOTAL ORIGINAL Bs</td>'+
        '<td class="border right ">'+factura.cabecera.montoTotalOriginal+'</td>'+
        '</tr>'+
        '</table>'+
        '</td>'+
        '</tr>'+
        '<tr>'+
        '<td colspan="3">'+
            '<h5>DATOS DE LA CONCILIACIÓN</h5>'+
        '<table width="100%" class="collapse">'+
        '<tr class="background" >'+
        '<th class="border" width="150px" >CÓDIGO PRODUCTO</th>'+
        '<th class="border">DESCRIPCIÓN</th>'+
        '<th class="border" width="50px">MONTO ORIGINAL</th>'+
        '<th class="border">MONTO FINAL</th>'+
        '<th class="border"  width="100px">MONTO CONCILIADO</th>'+
        '</tr>'+
        detalleConciliacion+
        '<tr>'+
        '<td colspan="2"></td>'+
        '<td class="border right text-h5 bold background" colspan="2">MONTO TOTAL CONCILIADO Bs</td>'+
        '<td class="border right">'+factura.cabecera.montoTotalConciliado+'</td>'+
        '</tr>'+
        '<tr>'+
        '<td colspan="2"></td>'+
            '<td class="border right  text-h5 bold background" colspan="2">'+textoCredito+' FISCAL IVA Bs</td>'+
        '<td class="border right">'+montoCredito+'</td>'+
        '</tr>'+
        '</table>'+
        '</td>'+
        '</tr>'+
        '<tr>'+
        '<td colspan="3" >'+
        '<table width="100%">'+
        '<tr>'+
            '<td class="center" valign=top>'+
        '<div class="left bold">Son: '+literal+' CON '+centavos+'/100 BOLIVIANOS</div>'+
        '<div class="text-h5">ESTA FACTURA CONTRIBUYE AL DESARROLLO DEL PAÍS, EL USO ILÍCITO SERÁ SANCIONADO PENALMENTE DE ACUERDO A LEY'+
        '</div>'+
        '<div class="text-h5">'+factura.cabecera.leyenda+'</div>'+
            '<div class="text-h5">“Este documento es la Representación Gráfica de un Documento Fiscal Digital emitido en una modalidad de facturación en línea”</div>'+
        '</td>'+
        '<td>'+
        "<img src='" + factura.img + "' width='89px'>" +
        '</td>'+
        '</tr>'+
        '</table>'+
        '</td>'+
        '</tr>'+
            `    <tr>
        <td colspan="3" class="">
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>    
            <table class='tablex' style='width: 100%;min-width: 100%;max-width: 100%;border: 1px solid black' >
              <tr class='trx' valign='top'>
                <td class='tdx' style='height: 50px;width: 50%;min-width: 50%;max-width: 50%'>
                  <b>CAJA: </b>${cliente.ventanilla} / C - ${factura.cabecera.numeroNotaConciliacion == null ? '' : factura.cabecera.numeroNotaConciliacion}<br><br>
                  <b>FECHA: </b>${this.setFecha(factura.cabecera.fechaEmision)}<br><br>
                  <b>HORA: </b> ${this.setFechaHora(cliente.fecha.date.substring(0, 19))} <br><br>
                </td>
                <td class='tdx' style='height: 50px;width: 50%;min-width: 50%;max-width: 50%'>
                  <b>Cuenta: </b>${cliente.cuenta==undefined?'':cliente.cuenta} - ${factura.cabecera.numeroFactura} / ${factura.cabecera.numeroNotaConciliacion == null ? '' : factura.cabecera.numeroNotaConciliacion}<br><br>
                  <b>Nombre/Razón Social: </b><small style='font-size: 9px'> ${cliente.razon_social}</small><br><br>
                  <b>TOTAL A PAGAR: </b>  ${this.round(factura.detalleConciliacion.montoFinal)}<br><br>
                </td>
              </tr>
            </table>
        </td>
    </tr>`+
        '</table>'+

        '</div>'
        )
    }
    static setFechaHora(fecha: string): string {
        if (fecha == null || fecha == undefined || fecha == '') {
            return '';
        }
        fecha=fecha.replace(' ','T');
        return DateTime.fromISO(fecha).toFormat('dd/MM/yyyy HH:mm:ss');
    }
    static round(value: number): string {
        return (Math.round(value * 100) / 100).toFixed(2);
    }
}